//import { gsap } from "gsap";
///import { ScrollTrigger } from "gsap/all";
//import { ScrollTrigger } from "gsap/ScrollTrigger";

//import { ScrollToPlugin } from "gsap/all";
import { CountUp } from "countup.js";
//import { DotLottie } from 'lottiefiles/dotlottie-web';

//import { DotLottie } from "<https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm>";


//gsap.registerPlugin(ScrollToPlugin);
//gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(ScrollSmoother);

const homeAnim = {
  init() {
    /* Smooth content */

    ScrollSmoother.create({
      wrapper: "#smooth-container",
      content: "#smooth-content",
      smooth: 1,
      effects: true,
    });

   


    var swiper = new Swiper(".swiper-section-mobile", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    /* GRILLE FULL SCREEN */

    //Random display
    const gsapColumns = [
      ".column1",
      ".column2",
      ".column3",
      ".column4",
      ".column5",
    ];

    gsapColumns.forEach((className) => {
      gsap.from(className, {
        duration: 0.5,
        opacity: 0,
        scale: 0,
        stagger: {
          from: "random",
          each: 0.1,
          axis: null,
        },
      });
    });

    /* SECTION LOGO */

    /* gsap.from(".line-2", {
      scrollTrigger: {
        trigger: ".section-logo",
        scrub: true,
        pin: true,
        start: "top top-=50%",
        end: "+=100%",
      },
      scaleX: 0,
      transformOrigin: "left center",
      ease: "none",
      background: "red",
      duration: "10",
    }); */

    LottieScrollTrigger({
      target: "#animationWindow",
      path: "https://lottie.host/b0756bcc-5046-4547-aeac-46bfa24ef56a/93OU5NaQAa.json",
      start: "center center",
      end: "+=bottom",
      pin: true,
      scrub: true ,
      markers: false,
      toggleActions: "restart none none none",
      speed: 'slow',
      duration: 7
      // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See https://greensock.com/docs/v3/Plugins/ScrollTrigger
     });
     
     function LottieScrollTrigger(vars) {
         let playhead = {frame: 0},
             target = gsap.utils.toArray(vars.target)[0],
             speeds = {slow: "+=4000", medium: "+=1000", fast: "+=500"},
             duration = vars.duration || 0.5,
             st = {trigger: target, pin: true, start: "top top", end: speeds[vars.speed] || "+=1000", scrub: 1},
             ctx = gsap.context && gsap.context(),
             animation = lottie.loadAnimation({
                 container: target,
                 renderer: vars.renderer || "svg",
                 loop: false,
                 autoplay: false,
                 path: vars.path,
                 rendererSettings: vars.rendererSettings || { preserveAspectRatio: 'xMidYMid slice' }
             });
             for (let p in vars) { // let users override the ScrollTrigger defaults
                 st[p] = vars[p];
             }
         animation.addEventListener("DOMLoaded", function() {

         


           let createTween = function() {
              animation.frameTween = gsap.to(playhead, {
                 frame: animation.totalFrames - 1,
                 ease: "none",
                 duration: duration,
                 onUpdate: () => animation.goToAndStop(playhead.frame, true),
                 scrollTrigger: st
             });
             return () => animation.destroy && animation.destroy();
           };
           ctx && ctx.add ? ctx.add(createTween) : createTween();
           // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
           ScrollTrigger.sort();
           ScrollTrigger.refresh();    
         });
         return animation;
     }


    const bgColors = gsap.utils.wrap([
      "linear-gradient(0deg, rgb(11, 11, 11) 0%, rgb(11, 11, 11) 33%, rgb(11, 11, 11) 42%, rgb(11, 11, 11) 49%, rgb(11, 11, 11) 56%, rgb(11, 11, 11) 61%, rgb(11, 11, 11) 67%, rgb(11, 11, 11) 74%, rgb(11, 11, 11) 84%, rgb(11, 11, 11) 88%, rgb(11, 11, 11) 95%, rgb(11, 11, 11) 99%)",
    ]);

    gsap.to(".section-logo", {
      scrollTrigger: {
        trigger: ".section-logo",
        start: "top top",
        scrub: true,
        end: "+=100%",
        markers: false,
      },
      duration: "20",
      background: bgColors,
    });

    /////

    /* HORIZONTAL ANIMATED TEXT LINE */

    //Big
    /* gsap.to(".text-line-big", {
      scrollTrigger: {
        trigger: ".section-txtlines",
        start: "top bottom",
        scrub: true,
        end: "+=120%",
        markers: false,
      },
      x: "100px",
    }); */

    //Medium
    /* gsap.to(".text-line-medium", {
      scrollTrigger: {
        trigger: ".section-txtlines",
        start: "top bottom",
        scrub: true,
        end: "+=120%",
        markers: false,
      },
      x: "-200px",
    }); */

    /* TWO COLUMNS GALLERY GOING UP AND DOWN ANIM */
    const t = gsap.to("#gallery", {
      duration: 40,
      ease: "none",
      y: `-50%`,
      repeat: -1,
      //yoyo: true
    });

    ScrollTrigger.create({
      trigger: "#gallery",
      start: "top 80%",
      end: "bottom top",
      onUpdate(self) {
        const velocity = self.getVelocity();
        if (velocity < 0) return;
        const timeScale = 3 + velocity / 400;
        gsap
          .timeline()
          .to(t, { duration: 0.1, timeScale })
          .to(t, { duration: 1.5, timeScale: 1 });
      },
    });

    const t2 = gsap.to("#gallery2", {
      duration: 40,
      ease: "none",
      y: `50%`,
      repeat: -1,
      //yoyo: true
    });

    ScrollTrigger.create({
      trigger: "#gallery2",
      start: "top 80%",
      end: "bottom top",
      onUpdate(self) {
        const velocity = self.getVelocity();
        if (velocity < 0) return;
        const timeScale = 3 + velocity / 400;
        gsap
          .timeline()
          .to(t2, { duration: 0.1, timeScale })
          .to(t2, { duration: 1.5, timeScale: 1 });
      },
    });

    /* FIGURES COUNT UP */

    let figureList = document.getElementsByClassName("figure");

// Create an array of objects with figure elements and their innerHTML values
let figuresData = Array.from(figureList).map((figure, index) => {
  return {
    element: figure,
    value: figure.innerHTML
  };
});


const options = {
  duration: 3,
  separator: "",
  decimal: "",
  enableScrollSpy: true,
  scrollSpyOnce: true,
};

figuresData.forEach((figureData, index) => {
  if (figureData.value.length > 0) {
    let counter = new CountUp(
      `figure_${index + 1}`,
      parseInt(figureData.value),
      options
    );

    if (index === 0) {
      gsap.to(".figures-list", {
        scrollTrigger: {
          trigger: ".section-figures",
          markers: false,
          start: "top 80%",
          end: "top",
          onUpdate() {
            //console.log("Update");
          },
          onEnter: () => {
            counter.start();
          },
        },
      });
    }
  } else {
    figureData.element.innerHTML = "-";
  }
});

    /* PANEL LABELS */

    let allowScroll = true; // sometimes we want to ignore scroll-related stuff, like when an Observer-based section is transitioning.
    let scrollTimeout = gsap.delayedCall(1, () => (allowScroll = true)).pause(); // controls how long we should wait after an Observer-based animation is initiated before we allow another scroll-related action
    let currentIndex = 0;
    let swipePanels = gsap.utils.toArray(".swipe-section .labels-bg-panel");

    // set z-index levels for the swipe panels
    gsap.set(swipePanels, { zIndex: (i) => swipePanels.length - i });

    // create an observer and disable it to start
    let intentObserver = ScrollTrigger.observe({
      id: "intentObserver",
      type: "wheel,touch",
      onUp: () => allowScroll && gotoPanel(currentIndex - 1, false),
      onDown: () => allowScroll && gotoPanel(currentIndex + 1, true),
      tolerance: 300,
      preventDefault: true,
      onEnable(self) {
        allowScroll = false;
        scrollTimeout.restart(true);
         //when enabling, we should save the scroll position and freeze it. This fixes momentum-scroll on Macs, for example.
        let savedScroll = self.scrollY();
        self._restoreScroll = () => self.scrollY(savedScroll); // if the native scroll repositions, force it back to where it should be
        document.addEventListener("scroll", self._restoreScroll, {
            passive: false,
          }) ;
      },
      onDisable: (self) =>
      document.removeEventListener("scroll", self._restoreScroll),
    });
    intentObserver.disable();

    // handle the panel swipe animations
    function gotoPanel(index, isScrollingDown) {
      // return to normal scroll if we're at the end or back up to the start
      if (
        (index === swipePanels.length && isScrollingDown) ||
        (index === -1 && !isScrollingDown)
      ) {
        intentObserver.disable(); // resume native scroll
        return;
      }
      allowScroll = false;
      scrollTimeout.restart(true);

      let target = isScrollingDown
        ? swipePanels[currentIndex]
        : swipePanels[index];
      gsap.to(target, {
        yPercent: isScrollingDown ? -100 : 0,
        duration: 0.5,
        
        onUpdate: () => {
          // Animate the .test blue square
          gsap.to(".labels-list ul li", {
            y: (i) => -150 * index, // Move each li element to align with the top of .tete
            //rotation: "+=360", // Rotate the square
            duration: 0.5, // Match the duration with the scroll animation
          });

          // Animate the li elements inside .tete
          gsap.to(".labels-list-framed ul li", {
            y: (i) => -150 * index, // Move each li element to align with the top of .tete
            duration: 0.5, // Match the duration with the scroll animation
          });
        },
        onComplete: () => {
          allowScroll = true;
        },
      });

      currentIndex = index;
    }

    // pin swipe section and initiate observer
    gsap.matchMedia().add("(min-width: 768px)", () => {
    ScrollTrigger.create({
      trigger: ".swipe-section",
      pin: true,
      start: "top top",
      markers: false,
      end: "+=200", // just needs to be enough to not risk vibration where a user's fast-scroll shoots way past the end
      onEnter: (self) => {
        if (intentObserver.isEnabled) {

          return;
        } // in case the native scroll jumped past the end and then we force it back to where it should be.
        self.scroll(self.start + 1); // jump to just one pixel past the start of this section so we can hold there.
        intentObserver.enable(); // STOP native scrolling
      },
      onEnterBack: (self) => {
        if (intentObserver.isEnabled) {
          return;
        } // in case the native scroll jumped backward past the start and then we force it back to where it should be.
        self.scroll(self.end - 1); // jump to one pixel before the end of this section so we can hold there.
        intentObserver.enable(); // STOP native scrolling
      },
    });
  });
    

        // Add event listeners to links inside the swipe-section
        const swipeSectionLinks = document.querySelectorAll(".link.link--arrowed");
        swipeSectionLinks.forEach((link) => {
          link.addEventListener("hover", (e) => {
          
            intentObserver.disable();
            setTimeout(() => {
              intentObserver.enable();
            }, 1000); // Adjust the timeout duration as needed
          });
        });



    /* TEAM BOARD */

    const boardPhotoWraps = document.querySelectorAll(".team-board-photos div");
    const teamBoardDescriptions = document.querySelectorAll(
      ".team-board-description div"
    );

    boardPhotoWraps.forEach((wrap, index) => {
      wrap.addEventListener("mouseover", () => {
        boardPhotoWraps.forEach((desc, descIndex) => {
          if (index === descIndex) {
            desc.classList.add("active");
          } else {
            desc.classList.remove("active");
          }
        });

        teamBoardDescriptions.forEach((desc, descIndex) => {
          if (index === descIndex) {
            gsap.fromTo(
              desc,
              {
                x: 100,
                duration: 0.5,
                opacity: 1,
                height: "fit-content",
                display: "block",
              },
              { x: 0 }
            );
            gsap.fromTo(
              desc.children,
              { opacity: 0 },
              { opacity: 1, y: 0, duration: 0.5, stagger: 0.1 }
            );
          } else {
            gsap.to(desc, {
              duration: 0,
              opacity: 0,
              height: 0,
              display: "none",
            });
          }
        });
      });
    });


    gsap.from(
      ".section-team-title, .team-img, .team-quote, .team-underquote",
      {
        scrollTrigger: {
          trigger: ".section-team",
          start: "top 80%",
          scrub: false,
          end: "+=100%",
          markers: false,
        },
        y: 200,
        opacity: 0,
        stagger: 0.5,
        duration: 1,
      }
    );


    gsap.from(".board-photo-wrap, .team-board-title", {
      scrollTrigger: {
        trigger: ".team-board-title",
        start: "bottom bottom",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      y: 200,
      opacity: 0,
      stagger: 0.3,
      duration: 1,
    });

    /* END OF PAGE ANIMATION */

    gsap.to(".section-team", {
      scrollTrigger: {
        trigger: "footer",
        start: "top bottom",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      width: "98%",
    });

    /* SCROLL TO FIX FROM MENU  */

    /* The anchors are passed as url parameters so it works when the users are coming from another page than the homepage */
    let urlSearchParams = new URLSearchParams(window.location.search);
    let anchor = urlSearchParams.get("anchor");

    if (anchor) {
      console.log("bug")
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: anchor,
          offsetY: 300,
        },
        onComplete: () => {
          intentObserver.disable();
        },
      });
    }

    /* let btnTeam = document.querySelector("#menu-item-157");

    btnTeam.addEventListener("click", (e) => {
      e.preventDefault();
      intentObserver.disable(); // Disable the observer before scrolling
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: "#equipe",
          offsetY: 300,
          overwrite: "auto",
        },
        onComplete: () => {
          intentObserver.disable();
        },
      });
    });

    let btnAbout = document.querySelector("#menu-item-148");

    btnAbout.addEventListener("click", (e) => {
      e.preventDefault();
      intentObserver.disable(); // Disable the observer before scrolling
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: "#qui-sommes-nous",
          offsetY: 300,
          overwrite: "auto",
        },
        onComplete: () => {
          intentObserver.disable();
        },
      });
    }); */
  },
};

export default homeAnim;
